import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyToSchedule() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Handy Heroes Marketplace",
    image: "https://handyheroesatl.com/img/logo.png",
    description: "A service contractor marketplace platform for home services including appliance repair, HVAC, plumbing, and electrical.",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Atlanta",
      addressRegion: "GA"
    },
    telephone: "(470) 847-9076",
    url: "https://handyheroesatl.com/",
    areaServed: ["Atlanta", "Alpharetta", "Marietta", "Gwinnett", "Cobb"],
    priceRange: "$$"
  };
  return <section id="readytoschedule" className="bg-background px-6 py-16 md:py-24">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }} />
      <div className="mx-auto max-w-4xl">
        <div className="flex flex-col items-center justify-center rounded-2xl border border-border bg-card px-6 py-12 text-center shadow-sm md:px-12 md:py-16">
          <h2 className="font-default text-3xl font-bold tracking-tight text-card-foreground sm:text-4xl">
            Ready to Schedule?
          </h2>
          <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
            Ask your pro about availability. Quick local matchmaking.
          </p>
          <div className="mt-8 flex w-full flex-col gap-4 sm:w-auto sm:flex-row sm:justify-center">
            <Button size="lg" asChild className="w-full sm:w-auto">
              <Link to="#bookingrequest">Request a Quote</Link>
            </Button>
            <Button size="lg" variant="outline" asChild className="w-full sm:w-auto">
              <Link to="tel:4708479076">
                <Phone className="mr-2 size-4" />
                Call (470) 847-9076
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}